import { CapoPlugin } from "/home/nodejs/kare-backoffice-v2/source/node_modules/.pnpm/@unhead+vue@1.11.18_vue@3.4.38/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];